import script from "./PatientFilterBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientFilterBar.vue?vue&type=script&lang=ts&setup=true"

import "./PatientFilterBar.vue?vue&type=style&index=0&id=51f3fb3d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f3fb3d"]])

export default __exports__